import styled from 'styled-components';

export const Container = styled.div`
  padding: ${({ theme }) => `${theme.spacing(5)} ${theme.spacing(6)}`};
  border-bottom: 1px solid ${({ theme }) => theme.palette.divider};
`;
